/* global google */
import React from 'react'
import PropTypes from 'prop-types'
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox'
import defaultOptions from './constants'

const GoogleMapsInfoBox = ({ children, onCloseClick }) =>
  <InfoBox options={{ ...defaultOptions, pixelOffset: new google.maps.Size(-30, -50) }} onCloseClick={ onCloseClick } >
    { children }
  </InfoBox>

GoogleMapsInfoBox.propTypes = {
  children: PropTypes.node,
  onCloseClick: PropTypes.func
}

export default GoogleMapsInfoBox
